<template lang="">
    <div>
        <uzhnet-back-button @click="$router.push('/main')" />

        <div class="header-block location-center">
            <div class="barrier">
                <img style="width: 112px" src="@/assets/icons/specials/left-block-header.svg" alt="">
            </div>
            <div class="label">
                рахунок
            </div>
            <div class="barrier">
                <img style="width: 112px" src="@/assets/icons/specials/right-block-header.svg" alt="">
            </div>
        </div>

        <div class="additional-services-block">
            <div v-for="check in store.additional_services" style="width: 100%;">
                <div v-for="service in check.services" class="additional-service-row">
                    <div class="additional-service-row__content">
                        <div class="additional-service-row__title">{{ service.name }}</div>
                        <div class="additional-service-row__price">{{ service.price }} грн</div>
                    </div>
                    <div class="additional-service-row__particles">
                        <div class="additional-particle-lt">
                            <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="0.5" y1="4" x2="0.5" y2="-2.18561e-08" stroke="#C7C8D1"/>
                                <line y1="0.5" x2="3.84" y2="0.5" stroke="#C7C8D1"/>
                            </svg>
                        </div>
                        <div class="additional-particle-lb">
                            <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="4" y1="3.5" x2="-0.000127148" y2="3.5" stroke="#C7C8D1"/>
                                <line x1="0.5" y1="3.84009" x2="0.5" y2="8.79983e-05" stroke="#C7C8D1"/>
                            </svg>
                        </div>
                        <div class="additional-particle-rb">
                            <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="3.50016" y1="3.13848e-07" x2="3.50016" y2="4" stroke="#C7C8D1"/>
                                <line x1="3.84" y1="3.5" x2="-4.37114e-08" y2="3.5" stroke="#C7C8D1"/>
                            </svg>
                        </div>
                        <div class="additional-particle-rt">
                            <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="1.67849e-07" y1="0.5" x2="4" y2="0.5" stroke="#C7C8D1"/>
                                <line x1="3.5" y1="1.96701e-07" x2="3.5" y2="3.84" stroke="#C7C8D1"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="total-block">
            <div class="total-block__title">Всього</div>
            <div class="total-block__particles-container">
                <div class="total-block__particles">
                    <div class="particle-lt">
                        <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0.5" y1="4.45142" x2="0.5" y2="0.451416" stroke="#E0C522"/>
                            <line y1="0.5" x2="3.84" y2="0.5" stroke="#E0C522"/>
                        </svg>
                    </div>
                    <div class="particle-lb">
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="4" y1="3.5" x2="1.67849e-07" y2="3.5" stroke="#E0C522"/>
                            <line x1="0.5" y1="3.84009" x2="0.5" y2="8.79983e-05" stroke="#E0C522"/>
                        </svg>

                    </div>
                    <div class="particle-rb">
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="3.50016" y1="3.13848e-07" x2="3.50016" y2="4" stroke="#E0C522"/>
                            <line x1="3.84" y1="3.5" x2="-4.37114e-08" y2="3.5" stroke="#E0C522"/>
                        </svg>
                    </div>
                    <div class="particle-rt">
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="1.24138e-07" y1="0.5" x2="4" y2="0.5" stroke="#E0C522"/>
                            <line x1="3.5" y1="1.96701e-07" x2="3.5" y2="3.84" stroke="#E0C522"/>
                        </svg>
                    </div>
                </div>
                <div class="total-block__price">{{ totalPrice.toFixed(2) }} грн</div>
            </div>
        </div>

        <div class="additional-services-check-pay">
            <uzhnet-button @click="payForAdditionalServices" class="additional-services-check-pay__button" :label="'Сплатити'" />
        </div>
    </div>
</template>
<script>
import { useMainStore } from '@/store/mainStore'
import { ref, onMounted } from 'vue'
import ApiManager from '@/services/ApiManager'
import { calculateFingerprint } from '@/services/fingerprint'
import { decryptMessage } from '@/services/cryptoUtils';
import { getAccountByLogin, dropAllAccounts } from '@/db/accountService';

import { useRouter } from 'vue-router'

function formatDescriptionInHtml(inputHtml) {
    // Регулярний вираз для пошуку description
    const descriptionRegex = /"description":"(.*?)"/;

    // Знайти description у рядку
    const match = inputHtml.match(descriptionRegex);

    if (match && match[1]) {
        const encodedDescription = match[1];

        // Декодуємо текст із символами Unicode
        const decodedDescription = JSON.parse(`"${encodedDescription}"`);

        // Замінюємо старе значення на декодоване
        const updatedHtml = inputHtml.replace(
            descriptionRegex,
            `"description":"${decodedDescription}"`
        );

        return updatedHtml;
    } else {
        console.error("Description not found in the input HTML string.");
        return inputHtml; // Повертаємо початковий HTML, якщо description не знайдено
    }
}

export default {
    name: "AdditionalServicesCheck",

    setup() {
        const store = useMainStore()
        const router = useRouter()

        const totalPrice = ref(0)

        onMounted(() => {
            totalPrice.value = store.additional_services.reduce((acc, check) => {
                return acc + check.services.reduce((acc, service) => {
                    return acc + +service.price
                }, 0)
            }, 0)
        })

        const payForAdditionalServices = async () => {
            const fingerprint = await calculateFingerprint()
            const maybeAccount = await getAccountByLogin(store.login)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            const response = await ApiManager.payForAdditionalServices(auth_token, store.additional_services[0].id)

            const formHtml = formatDescriptionInHtml(response.data)

            const action = formHtml.match(/action="([^"]*)/)[1] // get action from form
            const method = formHtml.match(/method="([^"]*)/)[1] // get method from form
            const id = formHtml.match(/id="([^"]*)/)[1] // get id from form

            const form = document.createElement('form')
            form.action = action
            form.method = method
            form.id = id
            form.innerHTML = formHtml
            document.body.appendChild(form)
            form.submit()

            router.push('/payment-success')
        }

        return {
            store,
            totalPrice,
            payForAdditionalServices
        }
    }
}
</script>
<style lang="scss">
    .additional-services-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;
        padding: 0 20px;
        margin-top: 120px;
    }

    .additional-service-row {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 5px 10px;
        background-color: rgba($color: #BBB, $alpha: .15);
    }

    .additional-service-row__content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .additional-particle-lt {
        position: absolute;
        top: -12px;
        left: -3px;
        z-index: 9999;
    }

    .additional-particle-lb {
        position: absolute;
        bottom: -10px;
        left: -3px;
        z-index: 9999;
    }

    .additional-particle-rb {
        position: absolute;
        bottom: -10px;
        right: -3px;
        z-index: 9999;
    }

    .additional-particle-rt {
        position: absolute;
        top: -12px;
        right: -3px;
        z-index: 9999;
    }

    .additional-service-row__title {
        font-size: 12px;
        font-weight: 500;
        color: #C7C8D1;
        font-family: 'Montserrat', sans-serif;
    }

    .additional-service-row__price {
        font-size: 18px;
        font-weight: 500;
        color: #E0C522;
        position: relative;
        top: 3px;
    }

    .total-block {
        display: flex;
        justify-content: space-evenly;
        margin-top: 120px;
    }

    .total-block__title {
        font-size: 20px;
        font-weight: 500;
        color: #C7C8D1;
        position: relative;
        top: 10px;
    }

    .total-block__price {
        font-size: 22px;
        font-weight: 500;
        color: #E0C522;
        position: relative;
        top: 3px;
    }

    .additional-services-check-pay {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 120px;
        padding: 0 20px;

        &__button {
            width: 100%;
        }

    }

    .total-block__particles-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        top: 5px;
        gap: 10px;
    }

    .total-block__particles {
        width: 100%;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    .particle-lt {
        position: absolute;
        top: -21px;
        left: -7px;
        z-index: 9999;
    }

    .particle-lb {
        position: absolute;
        bottom: -19px;
        left: -7px;
        z-index: 9999;
    }

    .particle-rb {
        position: absolute;
        bottom: -19px;
        right: -7px;
        z-index: 9999;
    }

    .particle-rt {
        position: absolute;
        top: -21px;
        right: -7px;
        z-index: 9999;
    }
</style>
